import CRUDFactory, { API_URL } from './crud_factory';

export const PortfolioFactory = new CRUDFactory({
  baseUrl: `${API_URL}portfolios/`,
});
export const StreamGroupFactory = new CRUDFactory({
  baseUrl: `${API_URL}stream_groups/`,
});
export const BeelineRoutingFactory = new CRUDFactory({
  baseUrl: `${API_URL}beeline_routings/`,
});
export const EngagementFactory = new CRUDFactory({
  baseUrl: `${API_URL}engagements/`,
});
export const SnapshotBundleFactory = new CRUDFactory({
  baseUrl: `${API_URL}snapshot_bundles/`,
});
export const HaulerAccountFactory = new CRUDFactory({
  baseUrl: `${API_URL}hauler_accounts/`,
});
export const HaulerLiquidationFactory = new CRUDFactory({
  baseUrl: `${API_URL}hauler_liquidations`,
});
export const CartTypeFactory = new CRUDFactory({
  baseUrl: `${API_URL}cart_types/`,
});
export const BillChargeRepositoryFactory = new CRUDFactory({
  baseUrl: `${API_URL}bill_charge_repositories/`,
});
export const InstructionFactory = new CRUDFactory({
  baseUrl: `${API_URL}instructions/`,
});
export const LoaAgreementCRUDFactory = new CRUDFactory({
  baseUrl: `${API_URL}loa_agreements/`,
});
export const TaxExemptionFactory = new CRUDFactory({
  baseUrl: `${API_URL}tax_exemptions/`,
});


// These below are dynamically used by app/webpack/apps/bills_input/actions/bill_actions.ts
// when creating bill related lines. Part of old bills input.
export const CostBasedServiceFactory = new CRUDFactory({
  baseUrl: `${API_URL}cost_based_services/`,
});
export const RateBasedServiceFactory = new CRUDFactory({
  baseUrl: `${API_URL}rate_based_services/`,
});
export const CostBasedBillServiceFactory = new CRUDFactory({
  baseUrl: `${API_URL}cost_based_bill_services/`,
});
export const RateBasedBillServiceFactory = new CRUDFactory({
  baseUrl: `${API_URL}rate_based_bill_services/`,
});
export const BillDebitFactory = new CRUDFactory({
  baseUrl: `${API_URL}bill_debits/`,
});
export const BillCreditFactory = new CRUDFactory({
  baseUrl: `${API_URL}bill_credits/`,
});
export const BillFeeFactory = new CRUDFactory({
  baseUrl: `${API_URL}bill_fees/`,
});
export const BillChargeFactory = new CRUDFactory({
  baseUrl: `${API_URL}bill_charges/`,
});
export const StreamDiversionFactory = new CRUDFactory({
  baseUrl: `${API_URL}stream_diversions/`,
});